// color design tokens export
export const colorTokens = {
  grey: {
    0: "#FFFFFF",
    10: "#F6F6F6",
    50: "#F0F0F0",
    100: "#E0E0E0",
    200: "#C2C2C2",
    300: "#A3A3A3",
    400: "#858585",
    500: "#666666",
    600: "#4D4D4D",
    700: "#333333",
    800: "#1A1A1A",
    900: "#0A0A0A",
    1000: "#000000",
  },
  primary: {
    50: "#F5DE93",
    100: "#F2D472",
    200: "#EFCA51",
    300: "#ECC031",
    400: "#E5B414",
    500: "#EAB815",
    600: "#C49A11",
    700: "#A3800E",
    800: "#83670B",
    900: "#624D08",
  },
  secondary: {
    0: "#F9CD8F",
    100: "#F7BE6D",
    200: "#F6AF4B",
    300: "#F4A029",
    400: "#EE900B",
    500: "#CC7C0A",
    600: "#AA6708",
    700: "#885206",
    800: "#663E05",
    900: "#442903",
  },
};

// mui theme settings
export const themeSettings = (mode) => {
  return {
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: "#4B4B4B",
            "& .MuiToolbar-root": {
              "& .MuiButtonBase-root": {
                color: "#FFF",
                fontWeight:"500",
              },
            },
          },
        },
      },
    },
    palette: {
      mode: mode,
      ...(mode === "dark"
        ? {
            // palette values for dark mode
            primary: {
              dark: colorTokens.primary[200],
              main: colorTokens.primary[500],
              light: colorTokens.primary[800],
            },
            neutral: {
              dark: colorTokens.grey[100],
              main: colorTokens.grey[200],
              mediumMain: colorTokens.grey[300],
              medium: colorTokens.grey[400],
              light: colorTokens.grey[700],
            },
            background: {
              default: colorTokens.grey[50],
              alt: colorTokens.grey[100],
            },
          }
        : {
            // palette values for light mode
            primary: {
              dark: colorTokens.primary[700],
              main: colorTokens.primary[500],
              light: colorTokens.primary[100],
            },
            neutral: {
              dark: colorTokens.grey[700],
              main: colorTokens.grey[500],
              mediumMain: colorTokens.grey[400],
              medium: colorTokens.grey[300],
              light: colorTokens.grey[50],
            },
            background: {
              default: colorTokens.grey[0],
              alt: colorTokens.grey[10],
            },
          }),
    },
    typography: {
      fontFamily: ["Roboto", "sans-serif"].join(","),
      fontSize: 12,
      h1: {
        fontFamily: ["Dancing Script", "sans-serif"].join(","),
        fontSize: 60,
      },
      h2: {
        fontFamily: ["Dancing Script", "sans-serif"].join(","),
        fontSize: 32,
      },
      h3: {
        fontFamily: ["Dancing Script", "sans-serif"].join(","),
        fontSize: 24,
      },
      h4: {
        fontFamily: ["Dancing Script", "sans-serif"].join(","),
        fontSize: 80,
      },
      h5: {
        fontFamily: ["Dancing Script", "sans-serif"].join(","),
        fontSize: 16,
      },
      h6: {
        fontFamily: ["Dancing Script", "sans-serif"].join(","),
        fontSize: 14,
      },
      footer: {
        backgroundColor: "#333",
        color: "#fff",
        padding: "48px 0",
      },
      logo: {
        color: "#fff",
        fontWeight: "bold",
        marginBottom: "16px",
      },
      icon: {
        color: "#fff",
      },
      text:{
        fontFamily: ["RaleWay", "sans-serif"].join(','),
        fontSize:16,
        marginBottom:"20px",
      },
      textTitle:{
        fontFamily: ["RaleWay", "sans-serif"].join(','),
        fontSize:24,
        fontWeight:"bold",
        marginBottom:"40px",
      }
    },
  };
};
